import createFields from '../createFields';
import immutable from '../structure/immutable';

export default createFields(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/Fields.js
// module id = 1192
// module chunks = 0